<div
  class="shadow-[0px_20px_40px_0px_rgba(166,166,166,0.25)] py-10 rounded-lg mx-3 md:mx-4 lg:mx-10 mb-10 lg:mt-12"
>
  <div class="flex items-center justify-center mx-auto">
    <svg-icon
      src="assets/svgs/email_verify_icon.svg"
      [svgStyle]="{ 'width.px': 77, 'height.px': 77 }"
      [ngClass]="{
        '[&_svg]:!w-10  [&_svg]:!h-10 md:[&_svg]:!w-[77px] md:[&_svg]:!h-[77px]': true
      }"
    ></svg-icon>
  </div>
  <div class="flex flex-col items-center gap-2 pt-6 text-center lg:pt-10">
    <h5
      class="text-base font-semibold md:text-lg lg:text-2xl text-tw-text-color"
    >
      Verify your Email address
    </h5>
    <div class="text-center text-[#5D5E5E] text-lg font-medium">
      <p class="px-4 text-xs lg:text-sm text-tw-text-color-accent">
        Please click on the link that has just been sent to your email address
        {{ emailSignal() }}.
      </p>
    </div>
    <div
      class="flex flex-col items-center gap-4 pt-6 text-sm text-center lg:pt-12 text-tw-text-color"
    >
      <p [ngClass]="{ 'text-tw-text-color': true }">
        Didn't receive the email?
      </p>
      <button
        [ngClass]="{
          ' bg-tw-primary text-white py-4 px-8 rounded-lg text-sm font-medium': true,
          'disabled:!text-[#86868666] disabled:!bg-[#E0E0E0]': true
        }"
        (click)="resendEmail()"
        [disabled]="true"
      >
        Resend Email
      </button>
      <span>03:11</span>
    </div>
  </div>
</div>
